<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
          <v-toolbar class="primary white--text">
            <v-toolbar-title class="headline text-xs-center">
                Bank Account Management
            </v-toolbar-title>
            
            <v-spacer></v-spacer>  
          
            <v-card-actions class="justify-center">
                <v-btn 
                    @click="getFirms"
                    outlined
                    large>
                    <v-icon left color='teal'>
                    add
                    </v-icon>
                    NEW BANK ACCOUNT  
                </v-btn>
            </v-card-actions>
            <!-- <router-link to="/Dashboard">
              <v-btn icon>
                <v-icon class="white--text">close</v-icon>
              </v-btn>
            </router-link> -->
          </v-toolbar>  
        <v-card>
            <template v-for="(item, index) in getAccount">
              <v-divider :key="item['.key']"></v-divider>
              <v-card :key="index">
                <!-- <v-card-title>
                  <v-card-text> 
                  Firm :- <b>{{firmbyId(item.firm)}}</b> &nbsp; &nbsp; &nbsp; 
                  Bank Name :- <b>{{item.bankName}}</b> &nbsp; &nbsp; &nbsp; 
                  A/C Category :- <b>{{item.accountCategory}}</b> &nbsp; &nbsp; &nbsp; 
                  Account Holder Name :- <b>{{item.accountHolderName}}</b> &nbsp; &nbsp; &nbsp;  -->
                  <!-- <v-card-text> Account Holder Name :- <b>{{item.accountHolderName}}</b></v-card-text> -->
                  <!-- <v-card-text> Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp; Account Type :- <b>{{item.accountType}}</b></v-card-text> -->
                  <!-- </v-card-text>
                  <v-card-text> 
                    Account Type :- <b>{{item.accountType}}</b> &nbsp; &nbsp; &nbsp; 
                    Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp; 
                    IFSC Code :- <b>{{(item.ifsccode).toUpperCase()}}</b> &nbsp; &nbsp; &nbsp; 
                    Location :- <b>{{item.accountLocation}}</b> &nbsp; &nbsp; &nbsp; 
                    Available Balance :- <b>&#8377;{{item.amount || 0 | amount}}</b> &nbsp; &nbsp; &nbsp;
                  </v-card-text> -->
                  <!-- <v-card-text> 
                        Opening Balance :- <b>&#8377;{{item.openingBalance}}</b>
                        Available Balance :- <b>{{item.amount}}</b> &nbsp; &nbsp; &nbsp; Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                  <!-- <v-card-text> Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                <!-- </v-card-title> -->

                <v-card-title class="body-1 primary--text font-weight-light" col> 
                    <v-flex xs5>
                      Firm :- <b class="font-weight-bold">{{firmbyId(item.firm)}}</b> 
                      <v-spacer/> 
                      Bank Name :- <b class="font-weight-bold">{{item.bankName}}</b> 
                      <v-spacer/> 
                      A/C Category :- <b class="font-weight-bold">{{item.accountCategory}}</b> 
                      <v-spacer/>  
                      Account Holder Name :- <b class="font-weight-bold">{{item.accountHolderName}}</b>  
                      <v-spacer/>
                      Account Type :- <b class="font-weight-bold">{{item.accountType}}</b> 
                    </v-flex>
                    
                    <v-flex xs1>
                    </v-flex>  
                    
                    <v-flex xs5>
                      Account Number :- <b class="font-weight-bold">{{item.accountnumber}}</b>  
                      <v-spacer/>
                      IFSC Code :- <b class="font-weight-bold">{{(item.ifsccode).toUpperCase()}}</b> 
                      <v-spacer/> 
                      Location :- <b class="font-weight-bold">{{item.accountLocation}}</b>  
                      <v-spacer/>
                      Available Balance :- <b class="font-weight-bold">&#8377;{{item.amount | amount}}</b> 
                    </v-flex>
                    <v-flex xs1>  
                      <v-btn flat icon class="primary white--text" @click="editAccount(item)">
                        <v-icon primary title class="white--text">edit</v-icon>
                      </v-btn> 
                    </v-flex>    
                  </v-card-title>

                <v-spacer/>
                <!-- <v-card-actions>
                  <v-btn flat left icon class="primary white--text" @click="editAccount(item)">
                    <v-icon primary title class="white--text">edit</v-icon>
                  </v-btn>  
                  <v-btn flat icon class="primary white--text" @click="deleteAccount(item['.key'])">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </template>
          </v-card>
        </v-card>
    </v-flex>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
      <v-form ref="addAccount" v-model="addNewAccountValid" lazy-validation>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Bank Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="items"
          @change="firmChange"
          :rules="requiredRule"
          v-model="currentFirm"
          label="Select Firms"
        ></v-select>
          <v-select
          item-text="name"
          item-value="id"
          :items="currentBankName"
          v-model="bankName"
          :rules="requiredRule"
          label="Choose Bank"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAccountCategory"
          v-model="accountCategory"
          @change="categoryChange"
          :rules="requiredRule"
          label="Choose account category"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAccountType"
          v-model="accountType"
          :rules="requiredRule"
          label="Choose Account Type"
        ></v-select>
          <v-text-field label="Account Holder Name" :rules="requiredRule" v-model="accountHolderName" :disabled="accholderdisabled"></v-text-field>
          <v-text-field label="Account Number" :rules="requiredRule" v-model="accountnumber" ></v-text-field>
          <v-text-field label="IFSC code" @change="getBankDetailsFromIFSC(false)" :rules="IFSC_Rules" v-model="ifsccode" ></v-text-field>
          <v-textarea 
            background-color="grey darken-1"
            color="black"
            label="Location" box :rules="requiredRule" v-model="accountLocation" ></v-textarea>
          
          <v-select v-model="tehsil.value" :items="gTehsil"  label="Tehsil"></v-select>
          <v-select v-model="district.value" :items="gDistrict" label="District"></v-select>       
          <v-select v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
          <v-select v-model="country.value" :items="gCountry" label="Country"></v-select>

          <!-- <v-select v-model="village.value" :items="gVillage"  label="Village"></v-select>
          <v-select v-model="block.value" :items="gBlock"  label="Block"></v-select> -->
          
          <v-text-field label="Amount" v-model.number="initialamount" ></v-text-field>
          <v-text-field label="Opening Balance" :rules="requiredRule" v-model="openingBalance" ></v-text-field>
          <v-menu
            :close-on-content-click="false"
            v-model="datepicker1"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="openingDate"
              label="Opening Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="openingDate" @input="datepicker1 = false"></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn primary title class="warning white--text" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn primary title class="primary white--text" flat="flat" @click="addNewAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" persistent max-width="400">
      <v-card>
      <v-form ref="editAccount" v-model="addNewAccountValid" lazy-validation>
         <v-card-title primary title class="primary white--text">
           <span class="headline">Edit Bank Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :rules="requiredRule"
          :items="itemsEdit"
          @change="firmChangeEdit"
          v-model="currentFirmEdit"
          label="Select Firms"
        ></v-select>
          <v-select
          item-text="name"
          item-value="id"
          :rules="requiredRule"
          :items="currentBankName"
          v-model="bankNameEdit"
          label="Choose Bank"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :rules="requiredRule"
          :items="currentAccountCategory"
          v-model="accountCategoryEdit"
          @change="categoryChangeEdit"
          label="Choose account category"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :rules="requiredRule"
          :items="currentAccountType"
          v-model="accountTypeEdit"
          label="Choose Account Type"
        ></v-select>
          <v-text-field label="Account Holder Name" :rules="requiredRule" v-model="accountHolderNameEdit" :disabled="accholderdisabledEdit"></v-text-field>
          <v-text-field label="Account Number" :rules="requiredRule" v-model="accountnumberEdit" ></v-text-field>
          <v-text-field label="IFSC code" :rules="IFSC_Rules" v-model="ifsccodeEdit"  @change="getBankDetailsFromIFSC(true)"  ></v-text-field>
          <v-textarea 
            background-color="grey darken-1"
            color="black"
            label="Location"  
            box :rules="requiredRule" 
            v-model="accountLocationEdit" >
          </v-textarea> 
          <v-select v-model="country.value" :items="gCountry" label="Country"></v-select>
          <v-select v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
          <v-select v-model="district.value" :items="gDistrict" label="District"></v-select>
          <v-select v-model="tehsil.value" :items="gTehsil"  label="Tehsil"></v-select>
          <!-- <v-select v-model="block.value" :items="gBlock"  label="Block"></v-select>
          <v-select v-model="village.value" :items="gVillage"  label="Village"></v-select> -->
          <v-text-field label="Amount" v-model="initialamountEdit" ></v-text-field>
          <v-text-field label="Opening Balance" :rules="requiredRule" v-model="openingBalanceEdit" ></v-text-field>
          <v-menu :close-on-content-click="false"
            v-model="datepicker2"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="openingDateEdit"
              label="Opening Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="openingDateEdit" @input="datepicker2 = false"></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn primary title class="warning white--text" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn primary title class="primary white--text" flat="flat" @click="updateNewAccount">
            Update
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { debug, debuglog } from 'util';
import axios from 'axios';

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Account',
  data () {
    return {
      datepicker2 : false,
      datepicker1 : false,
      requiredRule: [
        v => !!v || 'Field is Required',
      ],
      addNewAccountValid: false,
      dialog: false,
      dialogEdit:false,
      items:null,
      itemsEdit:null,
      bankName:null,
      accountType:null,
      accountCategory:null,
      currentFirmEdit:null,
      bankNameEdit:null,
      accountCategoryEdit:null,
      accountTypeEdit:null,
      accountHolderNameEdit:null,
      accountnumberEdit:null,
      ifsccodeEdit:null,
      accountLocationEdit:null,
      initialamountEdit:null,
      openingBalanceEdit:null,
      updateKey:null,
      accholderdisabled:false,
      accholderdisabledEdit:false,
      currentFirm:null,
      currentAccountCategory: [
        'Firm A/C',
        'Prop A/C',
        'Normal A/C',        
      ],
      currentBankName:[
        'Allahabad Bank',
        'Andhra Bank',
        'Axis Bank',
        'Bandhan Bank',
        'Bank of India',
        'Bank Of Baroda',
        'Bank Of Maharastra',
        'Canara Bank',
        'Central Bank Of India',
        'Corporation Bank',
        'Dena Bank',
        'DCB bank',
        'Google Pay',
        'HDFC bank',
        'ICICI Bank',
        'Indian Overseas Bank',
        'India Post',
        'Kotak Mahindra Bank',
        'Oriental Bank Of Commerce',
        'Paytm',
        'Phone Pe',
        'Punjab National Bank',
        'Punjab and Sind Bank',
        'State Bank Of India',
        'UCO Bank',
        'Union Bank Of India',
        'Vijaya Bank',
        'Yes Bank',
      ],
      currentAccountType:[        
        'Current A/C',
        'Cumulative A/C',
        'Demat A/C',
        'Fixed Deposit A/C',
        'Loan A/C',
        'NRI A/C',
        'Post-Office A/C',
        'Overdraft A/C',
        'Saving A/C',        
      ],
      IFSC_Rules: [
        v => {
            // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
            let reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
            return (
              v == undefined ||
              /^$/.test(v) ||
              reg.test(v) ||
              "IFSC must be Valid"
            );
          }
      ],
      ifsccode:null,
      accountLocation:null,
      accountHolderName: null,
      accountnumber:null,
      firms: [],
      initialamount:0,
      openingBalance : null,
      openingDate:null,
      openingBalanceEdit : null,
      openingDateEdit:null,
      village: {
        value: ''
      },
      block: {
        value: ''
      },
      tehsil: {
        value: ''
      },
      district: {
        value: ''
      },
      state: {
        value: ''
      },
      country: {
        value: ''
      },
    }
  },
  created () {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("operator", this.$root.$firebaseRefs.operator.orderByChild('brand').equalTo(this.selectedBrand));
    let today = new Date()
    this.date = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    this.openingDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    this.openingDateEdit = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
      if(this.$route.params.isNew) {
      // this.dialog = true; 
      this.getFirms(); 
    }
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand','brandFinYear']),
    getAccount () {
      if (this.selectedBrand) {
        return this.account.filter(item => item['brand'] === this.selectedBrand)
      }
    },
    accountCount () {
      return this.getAccount.length || 0
    } , 
     ...mapGlobalGetters({
      gVillage: 'village',
      gBlock: 'block',
      gTehsil: 'tehsil',
      gDistrict: 'district',
      gState: 'state',
      gCountry: 'country',
    }),
  },
  methods: {
    capitalize(s){
      s= s.toLowerCase();
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    getBankDetailsFromIFSC(isEdit){  
      let ifsc = isEdit ? this.ifsccodeEdit : this.ifsccode;
      let reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
       console.log(ifsc)
      if(ifsc && reg.test(ifsc)) {
          console.log("change")
           axios
          .get('https://ifsc.razorpay.com/'+ifsc)
          .then(response => {
            this.gState.push(this.capitalize(response.data.STATE));
            this.gDistrict.push(this.capitalize(response.data.DISTRICT));
            this.gTehsil.push(this.capitalize(response.data.CITY));
            setTimeout(() => {
              this.country.value = 'India';
              this.district.value = this.capitalize(response.data.DISTRICT);
              this.state.value = this.capitalize( response.data.STATE);
              this.tehsil.value = this.capitalize(response.data.CITY);
            }, 100);
            if(isEdit) {
              this.accountLocationEdit = response.data.BRANCH + " " +  response.data.ADDRESS;
            } else {
              this.accountLocation = response.data.BRANCH + " " +  response.data.ADDRESS;
            }
          })
      }
    },
    firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
    propbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].proprietor
    },
    addNewAccount () {
      if(!this.$refs.addAccount.validate()) {
        return console.info('not valid....')
      }
      let data ={
        brand:this.selectedBrand,
        brandFinYear : this.brandFinYear,
        firm:this.currentFirm,
        bankName:this.bankName,
        accountCategory:this.accountCategory,
        accountHolderName:this.accountHolderName,
        accountnumber:this.accountnumber,
        ifsccode:this.ifsccode,
        accountLocation:this.accountLocation,
        accountType:this.accountType,
        amount:Number(this.initialamount),
        openingBalance:Number(this.openingBalance),
        village: this.village.value || '',
        block: this.block.value || '',
        tehsil: this.tehsil.value,
        district: this.district.value,
        state: this.state.value,
        country: this.country.value,
      }
      this.$root.$firebaseRefs.account.push(data, () => {
        this.clearForm()
        this.cancelDialog();
      });
    },
    clearForm() {
        this.dialog=false;
        this.currentFirm="";
        this.bankName="";
        this.accountCategory="";
        this.ifsccode=null;
        this.accountHolderName=null;
        this.accountType="";
        this.accountLocation=null;
        this.accountnumber="";
        this.amount=0;
        this.openingBalance=0;
        this.initialamount = 0;
        this.village.value = null;
        this.block.value = null;
        this.tehsil.value = null;
        this.district.value = null;
        this.state.value = null;
        this.country.value = null;
    },
    updateNewAccount(){
      if(!this.$refs.editAccount.validate()) {
        return console.info('not valid....')
      }
      let data ={
          brand:this.selectedBrand,
          firm:this.currentFirmEdit,
          bankName:this.bankNameEdit,
          accountCategory:this.accountCategoryEdit,
          accountHolderName:this.accountHolderNameEdit,
          accountnumber:this.accountnumberEdit,
          ifsccode:this.ifsccodeEdit,
          accountLocation:this.accountLocationEdit,
          accountType:this.accountTypeEdit,
          amount:Number(this.initialamountEdit),
          openingBalance : this.openingBalanceEdit,
          openingDate : new Date(this.openingDateEdit).getTime(),
        }
        this.$root.$firebaseRefs.account.child(this.updateKey).update({
          brand:this.selectedBrand,
          firm:this.currentFirmEdit,
          bankName:this.bankNameEdit,
          accountCategory:this.accountCategoryEdit,
          accountHolderName:this.accountHolderNameEdit,
          accountnumber:this.accountnumberEdit,
          ifsccode:this.ifsccodeEdit,
          accountLocation:this.accountLocationEdit,
          accountType:this.accountTypeEdit,
          amount:Number(this.initialamountEdit),
          openingBalance : this.openingBalanceEdit,
          village: this.village.value || "",
          block: this.block.value || "",
          tehsil: this.tehsil.value || "",
          district: this.district.value,
          state: this.state.value,
          country: this.country.value,
          openingDate : new Date(this.openingDateEdit).getTime(),
        });
        // this.addInvoice();
        this.currentFirmEdit="";
        this.bankNameEdit="";
        this.accountCategoryEdit="";
        this.ifsccodeEdit=null;
        this.accountHolderNameEdit=null;
        this.accountTypeEdit="";
        this.accountLocationEdit=null;
        this.accountnumberEdit=0;
        this.initialamountEdit=0;
        this.openingBalanceEdit= null;
        this.openingDateEdit = null;
        this.village.value = null;
        this.block.value = null;
        this.tehsil.value = null;
        this.district.value = null;
        this.state.value = null;
        this.country.value = null;
        this.cancelDialog();
    },
    addInvoice(){
      let invoiceData = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          firm:this.currentFirm,
          paymentType:'bank',
          accountHolderName:this.accountHolderName,
          accountNumber:this.accountnumber,
          isCredited:true,
          totalAmount:Number(this.initialamount),
          openingBalance:Number(this.openingBalance),
          openingDate:Number(this.openingDate),
          date:Date.now()
      }
      this.$root.$firebaseRefs.invoice.push(invoiceData);
    },
    deleteAccount(key){
      confirm('Are you sure you want to delete this Bank Account') &&
      this.$root.$firebaseRefs.account.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
      if(this.$refs.addAccount) {
        this.$refs.addAccount.reset();
      }
      this.dialogEdit = false;
      if(this.$refs.editAccount) {
        this.$refs.editAccount.reset();
      }
    },
    getFirms () {
        this.dialog =true;
        let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
        this.itemsEdit = totalitem;
    },
    getAccount () {
      this.dialog =true;
        let account = this.account.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        account.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    },
    editAccount(key){
      this.dialogEdit = true;
      console.log(key)
      let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.itemsEdit = totalitem;

      this.currentFirmEdit= key.firm;
      this.bankNameEdit=key.bankName;
      this.accountCategoryEdit=key.accountCategory;
      this.accountTypeEdit=key.accountType;
      this.accountHolderNameEdit=key.accountHolderName;
      this.accountnumberEdit=key.accountnumber;
      this.ifsccodeEdit=key.ifsccode;
      this.accountLocationEdit=key.accountLocation;
      this.initialamountEdit=key.amount;
      this.openingBalanceEdit = key.openingBalance;
      this.village.value = key.village;
      this.block.value = key.block;
      this.tehsil.value = key.tehsil;
      this.district.value = key.district;
      this.state.value = key.state;
      this.country.value = key.country;
      this.openingDateEdit = key.openingDate ? new Date(key.openingDate).toISOString().substr(0, 10) : null,
      this.updateKey=key['.key']
    },
    categoryChange(){
      var self = this;
      setTimeout(function(){
        if(self.accountCategory=="Firm A/C" &&  self.currentFirm){
          self.accountHolderName=self.firmbyId(self.currentFirm)
          self.accholderdisabled=true
        }else if(self.accountCategory=="Prop A/C" &&  self.currentFirm){
          self.accountHolderName=self.propbyId(self.currentFirm)
          self.accholderdisabled=true;
        }else{
          self.accountHolderName=""
          self.accholderdisabled=false;
        }
      },1000)
    },
    firmChange(){
      var self = this;
      setTimeout(function(){
        if(self.accountCategory=="Firm A/C" &&  self.currentFirm){
          self.accountHolderName=self.firmbyId(self.currentFirm)
          self.accholderdisabled=true
        }else if(self.accountCategory=="Prop A/C" &&  self.currentFirm){
          self.accountHolderName=self.propbyId(self.currentFirm)
          self.accholderdisabled=true;
        }else{
          self.accountHolderName=""
          self.accholderdisabled=false;
        }
      },1000)
    },
    categoryChangeEdit(){
      var self = this;
      setTimeout(function(){
        if(self.accountCategoryEdit=="Firm A/C" &&  self.currentFirmEdit){
          self.accountHolderNameEdit=self.firmbyId(self.currentFirmEdit)
          self.accholderdisabledEdit=true
        }else if(self.accountCategoryEdit=="Prop A/C" &&  self.currentFirmEdit){
          self.accountHolderNameEdit=self.propbyId(self.currentFirmEdit)
          self.accholderdisabledEdit=true;
        }else{
          self.accountHolderNameEdit=""
          self.accholderdisabledEdit=false;
        }
      },1000)
    },
    firmChangeEdit(){
      var self = this;
      setTimeout(function(){
        if(self.accountCategoryEdit=="Firm A/C" &&  self.currentFirmEdit){
          self.accountHolderNameEdit=self.firmbyId(self.currentFirmEdit)
          self.accholderdisabledEdit=true
        }else if(self.accountCategoryEdit=="Prop A/C" &&  self.currentFirmEdit){
          self.accountHolderNameEdit=self.propbyId(self.currentFirmEdit)
          self.accholderdisabledEdit=true;
        }else{
          self.accountHolderNameEdit=""
          self.accholderdisabledEdit=false;
        }
      },1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Account/index.vue